import secondaryComponents from "../../..";
import { useProducts } from "./useProductTable";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import styles from "./styles.module.scss";
import { PurchaseOrderImage } from "../../../../../assets/svgImages";

export const ProductTable = ({
  billsForm,
  setBillsForm = () => {},
  ...validationParams
}) => {
  const { instance } = useProducts({
    billsForm,
    setBillsForm,
    ...validationParams,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <div className={`${globalStyles.tableWrapper} ${styles.billsFormTable}`}>
      {/* table section */}
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        classNames={`${styles.tableSection}`}
      >
        <div className="py-5 text-center">
          <PurchaseOrderImage />
          <h4>Items from the PO Number you selected will appear here</h4>
        </div>
      </secondaryComponents.TableHelper>
    </div>
  );
};
